module.exports = __webpack_public_path__ + "media/logo-motion.b174458a.webm";